import * as React from 'react'
import { Element } from 'react-scroll'

interface Props {
}

export default class OutClientsComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		return (
			<Element name="clients" className="section" id="clients">
				<div className="row">
					<div className="container">
						<div className="col-xs-12 col-sm-12 section-title-en">
							OUR CLIENTS
						</div>
						<div className="col-xs-12 col-sm-12 section-title-ja">
							プロダクトを通して、あなたのチーム・ユーザーと対話する。
						</div>
						<div className="col-xs-12 col-sm-12 section-description">
							クリエイティビティとイノベーションは、そのプロジェクトに関わるステークホルダーとの「対話」にかかっています。すべてのプロセスにおいて、まずは自分と、チームと、そしてユーザーとの対話をはじめましょう。
						</div>
						<div className="col-xs-12 col-sm-12 clients-image-pc">
							<img src="img/ic_clients.png"/>
						</div>
						<div className="col-xs-12 col-sm-12 clients-image-sp">
							<img src="img/ic_clients_sp.png"/>
						</div>

					</div>
				</div>
			</Element>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/welcome/components/outClientsComponent.tsx